import { useTranslation } from "react-i18next";
import { Buttons, Panel } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Semibold } from "capitalrx-components-2.0/lib/typography";
import { StackOrShelf } from "@/App/components/StackOrShelf";
import { ThemedButton } from "@/App/components";
import { DMRDrug } from "@/App/api/drug";

const TRANSLATION_PATH = "DIRECT_MEMBER_REIMBURSEMENT.prescriptionVaccineEquipmentDetails";

interface PrescriptionVaccineEquipmentCard {
  readonly dmrDrug: DMRDrug;
  readonly isSelected?: boolean;
  readonly onRemove?: () => void;
  readonly onSelect?: () => void;
}

export const DirectMemberReimbursementPrescriptionVaccineEquipmentCard = ({
  dmrDrug,
  isSelected = false,
  onRemove,
  onSelect,
}: PrescriptionVaccineEquipmentCard) => {
  const { t: translate } = useTranslation();

  return (
    <Panel appearance="primary">
      <StackOrShelf spacing="medium">
        <Stack alignment="left" spacing="small">
          <Shelf alignment="top">
            <Stack alignment="left" spacing="none">
              <Body style={{ color: "#60646D" }}>
                <Semibold>
                  {translate(`${TRANSLATION_PATH}.ndcOrUpc`)}: {dmrDrug.ndc}
                </Semibold>
              </Body>
              <Body>
                <Semibold>{dmrDrug?.drug_name}</Semibold>
              </Body>
            </Stack>
          </Shelf>
          <Stack.Spacer />
          <Shelf alignment="top">
            <Stack alignment="left" spacing="none">
              {dmrDrug?.dosage && <Body>{dmrDrug?.dosage}</Body>}
              {dmrDrug?.dosage_form && <Body>{dmrDrug?.dosage_form}</Body>}
            </Stack>
          </Shelf>
        </Stack>
        <Shelf.Spacer />
        {!isSelected && (
          <ThemedButton onClick={onSelect} appearance="secondary">
            {translate(`${TRANSLATION_PATH}.select`)}
          </ThemedButton>
        )}
        {isSelected && (
          <ThemedButton onClick={onRemove} appearance={Buttons.Destructive.Secondary.Large}>
            {translate(`${TRANSLATION_PATH}.remove`)}
          </ThemedButton>
        )}
      </StackOrShelf>
    </Panel>
  );
};
